const config = {
  apiUrl:
    import.meta.env.VITE_API_URL ||
    "https://development-server.stack.expert/api",
  marketplaceUrl:
    import.meta.env.VITE_MARKETPLACE_URL ||
    "https://development-hire.stack.expert",
  auth0Domain:
    import.meta.env.VITE_AUTH0_DOMAIN || "dev-giybfgex8iigorfs.us.auth0.com",
  auth0ClientId:
    import.meta.env.VITE_AUTH0_CLIENT_ID || "TJnKPF71Jdh7XKbweFBUmzOHLnfqSlMo",
  auth0Audience:
    import.meta.env.VITE_AUTH0_AUDIENCE ||
    "https://dev-giybfgex8iigorfs.us.auth0.com/api/v2/",
  circleUrl:
    import.meta.env.VITE_CIRCLE_URL || "https://stack-development.circle.so",
  auth0Namespace:
    import.meta.env.VITE_AUTH0_NAMESPACE ||
    "https://development.api.stack.expert",
  env: import.meta.env.VITE_ENV || "development",
};

export default config;
